// @ngInject
function inventoryCorrectionsDialogService($uibModal, InventoryingApiService, ProductsApiService) {

    return {
        showDialog: showDialog
    };

    function showDialog(inventoryId, articleId) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'inventoryCorrectionsDialogServiceController as vm',
            templateUrl: 'services/dialogs/inventoryCorrectionsDialog/inventoryCorrectionsDialog.tpl.html',
            size: 'lg'
        };

        modalDefaults.resolve = {
            inventoryRows: function() {
                return InventoryingApiService.getInventoryRowsRelatedToArticle(inventoryId, articleId);
            },
            stocks: function() {
                return ProductsApiService.getProductStocks(articleId);
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function inventoryCorrectionsDialogServiceController($uibModalInstance, inventoryRows, stocks, InventoryingApiService, ResourcesService) {
    var vm = this;

    var flexGrid = {};
    var rowData = [];
    var rowCollection = new wijmo.collections.CollectionView(rowData);
    var originalCellValue = '';

    var totalsGrid = {};

    var locationId = inventoryRows.data[0].inventory.location.id;

    vm.inventoryRows = inventoryRows.data;
    vm.articleVariants = pickOutArticleVariants(vm.inventoryRows);
    vm.stocksData = stocks.data;
    vm.totals = [
        {
            sumName: "Total",
            theoreticalTotal: 0,
            inventoriedTotal: 0,
            difference: 0
        }
    ];

    vm.closeModal = closeModal;
    vm.captureVariantsGrid = captureVariantsGrid;
    vm.beginEditing = beginEditing;
    vm.editEnded = editEnded;
    vm.saveChanges = saveChanges;

    function closeModal(isCompleted) {
        $uibModalInstance.close(isCompleted);
    }

    function saveChanges() {
        var inventoryToSend = {
            id: vm.inventoryRows[0].inventory.id,
            inventoryRows: []
        };

        _.forEach(rowData, function(data) {
            var keys = Object.keys(data);
            var variant1Name = data['variantDetails1Name'];
            _.forEach(keys, function(key) {
                if (key !== "variantDetails1Name") {

                    var relatedArticleVariant = _.find(vm.articleVariants, function(articleVariant) {
                        return articleVariant.variantDetail1.variantDetailName === variant1Name &&
                            articleVariant.variantDetail2.variantDetailName === key;
                    });

                    var specifiedQuantity = data[key].split('(')[0].trim();

                    var inventoryRow = {
                        articleVariant: relatedArticleVariant,
                        quantity: parseInt(specifiedQuantity)
                    };

                    inventoryToSend.inventoryRows.push(inventoryRow);
                }
            });
        });

        InventoryingApiService.updateInventory(inventoryToSend).then(function(response) {
            closeModal(response);
        }, function(error) {
            handleError(error);
        });
    }

    function captureVariantsGrid(sender) {
        flexGrid = sender;

        flexGrid.initialize({
            autoGenerateColumns: false,
            selectionMode: wijmo.grid.SelectionMode.Cell,
            allowDragging: wijmo.grid.AllowDragging.None,
            allowResizing: wijmo.grid.AllowResizing.Columns,
            headersVisibility: wijmo.grid.HeadersVisibility.Column,
            isReadOnly: false,
            frozenColumns: 1,
            itemsSource: rowCollection
        });

        initializeGridColumns();
    }

    function captureTotalsGrid(sender) {
        totalsGrid = sender;

        // Setting the item formatter, coloring the first line (total sum) differently.
        totalsGrid.itemFormatter = function(panel, r, c, cell) {
            var style = cell.style;
            var regularCellType = wijmo.grid.CellType.Cell;

            if (r === 0 && panel.cellType === regularCellType) {
                style.color = '#000000';
                style.backgroundColor = '#dddddd';
            }
        };
    }

    function calculateNewTotals() {
        var totalsObject = _.find(vm.totals, function(totalsEntry) {
            return totalsEntry.sumName === "Total";
        });

        totalsObject.theoreticalTotal = 0;
        totalsObject.inventoriedTotal = 0;
        totalsObject.difference = 0;

        _.forEach(rowData, function(data) {
            var keys = Object.keys(data);
            var variant1TotalsObject = _.find(vm.totals, function(variant1Entry) {
                return variant1Entry.sumName === data['variantDetails1Name'];
            });
            if (variant1TotalsObject === undefined) {
                variant1TotalsObject = {
                    sumName: data['variantDetails1Name'],
                    theoreticalTotal: 0,
                    inventoriedTotal: 0,
                    difference: 0
                };
                vm.totals.push(variant1TotalsObject);
            }

            variant1TotalsObject.theoreticalTotal = 0;
            variant1TotalsObject.inventoriedTotal = 0;
            variant1TotalsObject.difference = 0;

            _.forEach(keys, function(key) {
                if (key !== "variantDetails1Name") {
                    var currentData = data[key].split('(');
                    currentData[1] = currentData[1].substring(0, currentData[1].length - 1);

                    totalsObject.theoreticalTotal += parseInt(currentData[1]);
                    totalsObject.inventoriedTotal += parseInt(currentData[0]);

                    variant1TotalsObject.theoreticalTotal += parseInt(currentData[1]);
                    variant1TotalsObject.inventoriedTotal += parseInt(currentData[0]);

                    variant1TotalsObject.difference = variant1TotalsObject.inventoriedTotal - variant1TotalsObject.theoreticalTotal;
                }
            });
        });

        totalsObject.difference = totalsObject.inventoriedTotal - totalsObject.theoreticalTotal;
        if (totalsGrid.collectionView) {
            totalsGrid.collectionView.refresh();
        }
    }

    function initializeGridColumns() {
        // Need to wait for the grid to be initialized
        if (!flexGrid.columns) {
            setTimeout(initializeGridColumns, 100);
            return;
        }

        rowData.length = 0;
        flexGrid.columns.clear();
        rowCollection.refresh();

        // Add first row header column
        var rowHeader = new wijmo.grid.Column();
        rowHeader.binding = "variantDetails1Name";
        rowHeader.header = "Variant";
        rowHeader.allowSorting = false;
        rowHeader.allowResizing = true;
        rowHeader.width = '*';
        rowHeader.minWidth = 100;
        rowHeader.isReadOnly = false;
        flexGrid.columns.push(rowHeader);

        var columns = getDataColumns();

        // Add dynamic columns
        _.forEach(columns, function (variantDetail) {
            var c = new wijmo.grid.Column();
            c.binding = variantDetail.variantDetailName;
            c.header = variantDetail.variantDetailName;
            c.width = "*";
            c.minWidth = 100;
            c.allowSorting = false;
            c.allowResizing = true;
            c.inputType = 'text';
            c.isReadOnly = false;
            c.align = "right";
            flexGrid.columns.push(c);
        });

        loadGridData();
    }

    function getDataColumns() {
        var columns = [];

        // Group by nested variantDetail2 in the current articleVariants
        columns = _.groupBy(vm.articleVariants, function(variant) {
            return variant.variantDetail2.variantDetailName;
        });
        // Get the variantDetail2 from each group in an array
        columns = _.reduce(columns, function(newArray, val, key) {
            newArray.push(val[0].variantDetail2);
            return newArray;
        }, []);

        return _.sortBy(columns, 'sortOrder');
    }

    function loadGridData() {
        var articleVariants = _.groupBy(vm.articleVariants, function(articleVariant) {
            return articleVariant.variantDetail1.variantDetailName;
        });

        _.forEach(articleVariants, function(variantRowValues) {
            var r = {};
            _.forEach(variantRowValues, function(variantRowValue) {
                r.variantDetails1Name = variantRowValue.variantDetail1.variantDetailName;

                var relatedStock = getStockFor(r.variantDetails1Name, variantRowValue.variantDetail2.variantDetailName);
                var relatedInventoryRow = getInventoryRowFor(r.variantDetails1Name, variantRowValue.variantDetail2.variantDetailName);

                if (relatedStock === undefined || relatedStock.location.id !== locationId) {
                    relatedStock = {};
                    relatedStock['quantity'] = 0;
                }

                if (relatedInventoryRow === undefined) {
                    relatedInventoryRow = {};
                    relatedInventoryRow['quantity'] = 0;
                }

                r[variantRowValue.variantDetail2.variantDetailName] = relatedInventoryRow.quantity + " (" + relatedStock.quantity + ")";
            });
            rowData.push(r);
        });
        rowCollection.refresh();

        calculateNewTotals();
    }

    function getStockFor(variantDetail1Name, variantDetail2Name) {
        return _.find(vm.stocksData, function(stock) {
            return stock.articleVariant.variantDetail1.variantDetailName === variantDetail1Name &&
                stock.articleVariant.variantDetail2.variantDetailName === variantDetail2Name  &&
                stock.location.id === locationId;
        });
    }

    function getInventoryRowFor(variantDetail1Name, variantDetail2Name) {
        var result = _.find(vm.inventoryRows, function(inventoryRow) {
            return inventoryRow.articleVariant.variantDetail1.variantDetailName === variantDetail1Name &&
                   inventoryRow.articleVariant.variantDetail2.variantDetailName === variantDetail2Name;
        });

        return result;
    }

    function beginEditing(sender, e) {
        var rowNumber = flexGrid.selection.row;
        var columnNumber = flexGrid.selection.col;

        var columnHeader = flexGrid.columns[columnNumber].binding;

        var keys = Object.keys(rowData[rowNumber]);

        originalCellValue = angular.copy(rowData[rowNumber][columnHeader]);

        rowData[rowNumber][columnHeader] = rowData[rowNumber][columnHeader].split('(')[0].trim();
        rowCollection.refresh();
    }

    function editEnded(sender, e) {
        var rowNumber = flexGrid.selection.row;
        var columnNumber = flexGrid.selection.col;
        var keys = Object.keys(rowData[rowNumber]);

        var columnHeader = flexGrid.columns[columnNumber].binding;

        rowData[rowNumber][columnHeader] = rowData[rowNumber][columnHeader] + " (" + originalCellValue.split('(')[1];
        rowCollection.refresh();
        calculateNewTotals();
    }

    function pickOutArticleVariants(inventoryRows) {
        var articleVariants = [];

        _.forEach(inventoryRows, function(inventoryRow) {
            articleVariants.push(inventoryRow.articleVariant);
        });

        return articleVariants;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('services.dialogs.inventoryCorrectionsModal', [])
    .service('inventoryCorrectionsDialogService', inventoryCorrectionsDialogService)
    .controller('inventoryCorrectionsDialogServiceController', inventoryCorrectionsDialogServiceController);
